export const TO_DO = 1;
export const NOT_DONE = 2;
export const DONE = 3;
export const IN_PROGRESS = 4;

interface Status {
    name: string;
    color: string;
}

export const TASK_STATUS: { [index: number]: Status } = {
    1: { name: 'To do', color: '#03a9f4' },
    2: { name: 'Not done', color: '#f44336' },
    3: { name: 'Done', color: '#4caf50' },
    4: { name: 'In progress', color: '#ff9800' },
};
